import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppState } from '../../../store/app-reducers';

@Component({
  selector: 'app-confirm-cancel',
  templateUrl: './result-exe-push.page.html',
  styleUrls: ['./result-exe-push.page.scss'],
})
export class ResulExePushPage implements OnInit, OnDestroy {

  @Input() title = '';
  @Input() body = '';

  public responsable: Observable<string>;

  constructor(
    private modalCtrl: ModalController
    , private store: Store<AppState>
  ) {
    this.responsable = this.store.select('userData').pipe(map(value => value.Responsable));
  }

  ngOnInit() { }

  ngOnDestroy() { }

  public onClose = (accept: boolean) => this.modalCtrl.dismiss(accept);

}
